import { UserInfo } from '../../Login/common/defaults';
import { SET_USER, LOG_OUT } from '../../Login/redux-objects/actions';
import { SET_LOADING_WITH_MESSAGE } from './actions';
export const SET_SHOW_SIDEBAR = 'SET_SHOW_SIDEBAR';
export const SET_SHOW_HEADER = 'SET_SHOW_HEADER';
export const SET_BYPASS_REPORT_IMAGE = 'SET_BYPASS_REPORT_IMAGE';

export interface IAppState {
  backendURL: string;
  elasticSearchURL: string;
  formIOUrl: string;
  applicationName: string;
  currentUser: UserInfo;
  loggedIn: boolean;
  loggingOut: boolean;
  signedOut: boolean;
  showLoading: boolean;
  loadingText: string;
  showSidebar: boolean;
  showHeader: boolean;
  bypassReportImage: boolean;
}

const backendURL = (window as any).backendURL;
const elasticSearchURL = (window as any).elasticSearchURL;
const formIOUrl = process.env.FORMIO_URL || (window as any).formIOUrl;
const sessionUser = JSON.parse(sessionStorage.getItem('sessionUser'));

export const initialState: IAppState = {
  backendURL,
  elasticSearchURL,
  formIOUrl,
  applicationName: 'NCID',
  currentUser: sessionUser,
  loggedIn: sessionUser,
  loggingOut: false,
  signedOut: false, // signed out on purpose
  showLoading: false,
  loadingText: '',
  showSidebar: true,
  showHeader: true,
  bypassReportImage: false,
};

export default (state: IAppState = initialState, action: any) => {
  let _state = { ...state };
  switch (action.type) {
    case SET_USER:
      _state.currentUser = { ...action.value };
      sessionStorage.setItem('sessionUser', JSON.stringify(action.value));
      _state.loggedIn = true;
      _state.loggingOut = false;
      return _state;
    case LOG_OUT:
      _state.currentUser = null;
      sessionStorage.removeItem('sessionUser');
      _state.loggedIn = false;
      _state.loggingOut = true;
      return _state;
    case SET_LOADING_WITH_MESSAGE:
      _state.showLoading = action.showLoading;
      _state.loadingText = action.message;
      return _state;
    case SET_SHOW_SIDEBAR:
      _state.showSidebar = action.value;
      return _state;
    case SET_SHOW_HEADER:
      _state.showHeader = action.value;
      return _state;
    case SET_BYPASS_REPORT_IMAGE:
      _state.bypassReportImage = action.value;
      return _state;
    default:
      return state;
  }
};
